import { GuestCharts } from '../../../_metronic/partials/widgets/charts/GuestCharts'

const GuestReport = () => {
  return (
    <>
    <GuestCharts className='card-xl-stretch mb-xl-8' />
   </>
  )
}

export { GuestReport }
